<template>
  <div>
    <div @click="showModal">
      查看机器人心跳
    </div>
    <a-modal v-model="visible" title="机器人心跳及网速" @ok="handleOk" width=1100px>
      <p>机器人心跳及网速</p>
      <p class="pagesz">page size: &nbsp;&nbsp;&nbsp;</p>  
      <a-input-number class="pagesz" v-model="pagesize" :min="1" />
      <a-button class="pagesz" @click="getData(record.client_id, current_page, page_size)">刷新</a-button>
        <a-table :columns="columns" :data-source="data" :pagination="pagination">
            <a slot="name" slot-scope="text">{{ text }}</a>
            <span slot="http_status" slot-scope="http_status">
                <a-tag
                v-for="tag in http_status"
                :key="tag"
                :color="tag === 'true' ? 'green' : 'red'"
                >
                {{ tag.toUpperCase() }}
                </a-tag>
            </span>
            <span slot="mq_status" slot-scope="mq_status">
                <a-tag
                v-for="tag in mq_status"
                :key="tag"
                :color="tag === 'true' ? 'green' : 'red'"
                >
                {{ tag.toUpperCase() }}
                </a-tag>
            </span>
            <span slot="http_heartbeat_time" slot-scope="http_heartbeat_time, record" >
                <a @click="changeToNormalTimeFormat(record, 1)">{{http_heartbeat_time}}</a>
            </span>
            <span slot="mq_heartbeat_time" slot-scope="mq_heartbeat_time, record" >
                <a @click="changeToNormalTimeFormat(record, 2)">{{mq_heartbeat_time}}</a>
            </span>
        </a-table>
        <a-button type="default" @click="clickLeft"> <a-icon type="left" />Go back </a-button>
        <a-button type="default" @click="clickMiddle">{{current_page}}</a-button>
        <a-button type="default" @click="clickRight"> Go forward<a-icon type="right" /> </a-button>
        <div v-show="enableGoAnyPage">
            <a-input-number id="inputNumber" v-model="pageToGo" :min="1" /><a-button type="link" @click="goAnyPage">Go!</a-button>
        </div>
    </a-modal>
  </div>
</template>
<script>
const columns = [
    {
    title: 'index',
    dataIndex: 'index',
    key: 'index',
  },
  {
    title: 'nickname',
    dataIndex: 'nickname',
    key: 'nickname',
  },
  {
    title: 'bot_username',
    dataIndex: 'bot_username',
    key: 'bot_username',
  },
  {
    title: 'Device',
    dataIndex: 'device',
    key: 'device',
    width: 80,
  },
  {
    title: 'http_heartbeat_time',
    dataIndex: 'http_heartbeat_time',
    key: 'http_heartbeat_time',
    scopedSlots: { customRender: 'http_heartbeat_time' },
    sorter: (a, b) => a.save_http_time - b.save_http_time,
  },
  {
    title: 'http_status',
    dataIndex: 'http_status',
    key: 'http_status',
    scopedSlots: { customRender: 'http_status' },
    filters:[
        {
            text: 'True',
            value: 'true',
        },
        {
            text: 'False',
            value: 'false',
        }
    ],
    onFilter: (value, record) => record.http_status.indexOf(value) === 0,
  },
  {
    title: 'mq_heartbeat_time',
    dataIndex: 'mq_heartbeat_time',
    key: 'mq_heartbeat_time',
    scopedSlots: { customRender: 'mq_heartbeat_time' },
    sorter: (a, b) => a.save_mq_time - b.save_mq_time,
  },
  {
    title: 'mq_status',
    dataIndex: 'mq_status',
    key: 'mq_status',
    scopedSlots: { customRender: 'mq_status' },
    filters:[
        {
            text: 'True',
            value: 'true',
        },
        {
            text: 'False',
            value: 'false',
        }
    ],
    onFilter: (value, record) => record.mq_status.indexOf(value) === 0,
  }
];
const axios = require('axios')
export default {
  props:["record"],
  data() {
    return {
        bot_list: [],
        visible: false,
        current_page: 1,
        pagesize: 1000,
        data : [],
        columns,
        pageToGo: 1,
        pagination: false,
        enableGoAnyPage: false,
        getUserBotUrlPostFix: 'ClientBotStatus/get_user_bot',
        url : ""
    };
  },
  watch:{
      pagesize(val, oldVal){
          this.getData(this.record.client_id, 1, val);
          this.current_page = 1;
      }
  },
  methods: {
    getData (clientId, page, pagesize) {
      var index = 0;
      axios.post(global.DOMAIN + global.API_VERSION + this.getUserBotUrlPostFix, {
        client_ids: clientId,
        token: sessionStorage.token,
        page: page,
        page_size: pagesize,
      })
        .then((data) => {
          if(data.data.err_code === 0){
              this.data = data.data.content.robots_status_list;
                  this.data.forEach(function(item) {
                      item["index"] = index;
                      index = index + 1;
                      if(item['http_status'] == true){
                        item['http_status'] = ['true']
                      }
                      else if(item['http_status'] == false){
                          item['http_status'] = ['false']
                      }
                      if(item['mq_status'] == true){
                          item['mq_status'] = ['true']
                      }
                      else if(item['mq_status'] == false){
                          item['mq_status'] = ['false']
                      }
                      if(item['http_heartbeat_time'] == null){
                          item['save_http_time'] = item['http_heartbeat_time']
                          item['http_heartbeat_time'] = ""
                      }
                      else{
                          item['save_http_time'] = item['http_heartbeat_time']
                          item['http_heartbeat_time'] = new Date(parseInt(item['http_heartbeat_time']) * 1000).toLocaleString().replace(/:\d{1,2}$/,' ')
                      }
                      if(item['mq_heartbeat_time'] == null){
                          item['save_mq_time'] = item['mq_heartbeat_time']
                          item['mq_heartbeat_time'] = ""
                      }
                      else{
                          item['save_mq_time'] = item['mq_heartbeat_time']
                          item['mq_heartbeat_time'] = new Date(parseInt(item['mq_heartbeat_time']) * 1000).toLocaleString().replace(/:\d{1,2}$/,' ')
                      }
                      return item
                  })
          }
        })
    },
    showModal() {
      this.visible = true;
      this.getData(this.record.client_id, 1, this.pagesize)
    },
    handleOk(e) {
      this.visible = false;
    },
    clickLeft(){
        if(this.current_page > 1){
            this.current_page = this.current_page - 1;
            this.getData(this.record.client_id, this.current_page, this.pagesize)
        }
    },
    clickRight(){
        this.current_page = this.current_page + 1;
        this.getData(this.record.client_id, this.current_page, this.pagesize)
    },
    clickMiddle(){
        this.enableGoAnyPage = true;
    },
    goAnyPage(){
        this.enableGoAnyPage = false;
        this.current_page = parseInt(this.pageToGo);
        this.getData(this.record.client_id, this.current_page, this.pagesize)
    },
    changeToNormalTimeFormat(record, type){ // type: 1 http_heartbeat_time, 2 mq_heartbeat_time
        if(type == 1){
            var temp = '';
            temp = record['save_http_time']
            record['save_http_time'] = record['http_heartbeat_time']
            record['http_heartbeat_time'] = temp
        }
        else if(type == 2){
            var temp = '';
            temp = record['save_mq_time']
            record['save_mq_time'] = record['mq_heartbeat_time']
            record['mq_heartbeat_time'] = temp
        }
    }
  }
}
</script>
<style>
    .pagesz{
        float: left;
    }
</style>
